"use strict";

var _objectWithoutProperties = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var use_toggle_state_hook_1 = __importDefault(require("../../hooks/use-toggle-state.hook"));

var custom_modal_component_1 = __importDefault(require("../custom-modal/custom-modal.component"));

var async_progress_modal_content_component_1 = __importDefault(require("./async-progress-modal-content.component"));

var useDisableClose = function useDisableClose() {
  var _use_toggle_state_hoo = use_toggle_state_hook_1.default(true),
      canClose = _use_toggle_state_hoo.state,
      disableClose = _use_toggle_state_hoo.handleOff,
      enableClose = _use_toggle_state_hoo.handleOn;

  return {
    canClose: canClose,
    disableClose: disableClose,
    enableClose: enableClose
  };
};

var AsyncProgressModal = function AsyncProgressModal(_ref) {
  var isOpen = _ref.isOpen,
      handleClose = _ref.handleClose,
      otherProps = _objectWithoutProperties(_ref, ["isOpen", "handleClose"]);

  var _useDisableClose = useDisableClose(),
      canClose = _useDisableClose.canClose,
      disableClose = _useDisableClose.disableClose,
      enableClose = _useDisableClose.enableClose;

  return react_1.default.createElement(custom_modal_component_1.default, {
    isOpen: isOpen,
    handleClose: handleClose,
    needCloseIcon: canClose,
    disableBackdropClick: !canClose
  }, react_1.default.createElement(async_progress_modal_content_component_1.default, Object.assign({
    handleClose: handleClose,
    disableClose: disableClose,
    enableClose: enableClose
  }, otherProps)));
};

exports.default = AsyncProgressModal;